import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Typography,
  CircularProgress,
} from "@mui/material";
import { oauthClientService } from "../../utils/services/o-auth-client";
import { toast } from "react-toastify";

const TokenGenerationModal = ({
  open,
  onClose,
  client,
  setTokenGeneratedClientId,
  regenerateContext,
}) => {
  const [clientSecret, setClientSecret] = useState("");
  const code = regenerateContext
    ? regenerateContext.refresh_token
    : localStorage.getItem("oauth_code");
  const redirect_uri = localStorage.getItem("oauth_selected_uri");

  const handleGenerateToken = async () => {
    const payload = {
      code,
      grant_type: regenerateContext ? "refresh_token" : "authorization_code",
      client_id: client.client_id,
      client_secret: clientSecret,
      redirect_uri,
    };
    if (regenerateContext) {
      payload.refresh_token = regenerateContext.refresh_token;
      delete payload.code; // Remove code if regenerating token
    }

    try {
      const response = await oauthClientService.generateToken(payload);
      toast.success("Token generated sucessfully.");
      setTokenGeneratedClientId(client._id);
    } catch (err) {
      console.error("Token generation failed:", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Generate Token</DialogTitle>
      <DialogContent>
        <TextField
          label="Client ID"
          value={client?.client_id || ""}
          fullWidth
          disabled
          margin="normal"
          size="small"
        />
        <TextField
          label="Client Secret"
          value={clientSecret}
          fullWidth
          margin="normal"
          size="small"
          onChange={(e) => setClientSecret(e.target.value)}
        />
        {regenerateContext ? (
          <></>
        ) : (
          <TextField
            label="Redirect URI"
            value={redirect_uri}
            fullWidth
            margin="normal"
            size="small"
            disabled
          />
        )}
        <TextField
          label="Authorization Code"
          value={code}
          fullWidth
          margin="normal"
          size="small"
          disabled
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleGenerateToken} variant="contained">
          Authenticate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TokenGenerationModal;
